export default __webpack_public_path__ + "static/6-979a7d94fc14c756197b380471772793.jpg";